import { Controller } from "stimulus"
import $ from 'jquery'

export default class extends Controller {
  static targets = ['menu']

  load() {
    this.menuTarget.innerHTML = "<div class='notifications-spinner'><div class='bounce1'></div><div class='bounce2'></div><div class='bounce3'></div></div>"

    $.ajax({
      method: 'get',
      url: this.url,
      dataType: 'script'
    })
  }

  get url() {
    return this.element.dataset.url
  }
}
